import { post } from '../utils/httpClient'
import { PostExchangeResponse } from './types'
import { getRedDataApiPaths } from '../config'

export const apiPostExchangeVoucher = async (rewardId: string, rewardParentId: string, stepUp?: boolean) => {
  const body = { rewardId, rewardParentId }
  const response = (await post(`${getRedDataApiPaths().RED_API_EXCHANGE}`, true, stepUp, body)) as PostExchangeResponse
  return response.vouchers[0].voucherId as string
}
